import { render, staticRenderFns } from "./MarketLivePreviewTerminal.vue?vue&type=template&id=bd475728&scoped=true"
import script from "./MarketLivePreviewTerminal.vue?vue&type=script&lang=js"
export * from "./MarketLivePreviewTerminal.vue?vue&type=script&lang=js"
import style0 from "./MarketLivePreviewTerminal.vue?vue&type=style&index=0&id=bd475728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd475728",
  null
  
)

export default component.exports